import { MutationTree } from 'vuex';
import { ActionStatus } from '@/application/types';
import { OrderSearchState, OrderIdentification, Order } from '../types';
import { orderSearchStateDefaults } from './defaults';

export const orderSearchMutations: MutationTree<OrderSearchState> = {

  clear(state) {
    state.hasSearchBeenTriggered = orderSearchStateDefaults.hasSearchBeenTriggered;
    state.hasSearchResultedIn0Results = orderSearchStateDefaults.hasSearchResultedIn0Results;
    state.lastSearchTerm = orderSearchStateDefaults.lastSearchTerm;
    state.orderIdentifications = orderSearchStateDefaults.orderIdentifications;
    state.currentOrderId = orderSearchStateDefaults.currentOrderId;
    state.currentOrder = orderSearchStateDefaults.currentOrder;
    state.getOrderIdentificationsByOrderNumberStatus = orderSearchStateDefaults.getOrderIdentificationsByOrderNumberStatus;
    state.getCurrentOrderStatus = orderSearchStateDefaults.getCurrentOrderStatus;
  },

  // Update search term
  updateLastSearchTerm(state, searchTerm: string) {
    state.lastSearchTerm = searchTerm;
  },

  // Set current order id
  setCurrentOrderId(state, orderId: string) {
    state.currentOrderId = orderId;
  },

  // Get product identifications by EAN

  getOrderIdentificationsByOrderNumberStarted(state) {
    state.getOrderIdentificationsByOrderNumberStatus = ActionStatus.InProgress;
  },

  getOrderIdentificationsByOrderNumberSucceeded(state, orderIdentifications: OrderIdentification[]) {
    state.getOrderIdentificationsByOrderNumberStatus = ActionStatus.Successful;
    state.orderIdentifications = orderIdentifications;
    state.hasSearchBeenTriggered = true;
    state.hasSearchResultedIn0Results = orderIdentifications.length === 0;
    if (orderIdentifications.length === 1) {
      state.currentOrderId = orderIdentifications[0].orderId;
    }
  },

  getOrderIdentificationsByOrderNumberFailed(state) {
    state.getOrderIdentificationsByOrderNumberStatus = ActionStatus.Failed;
  },

  // Get current order

  getCurrentOrderStarted(state) {
    state.getCurrentOrderStatus = ActionStatus.InProgress;
  },

  getCurrentOrderSucceeded(state, order: Order) {
    state.getCurrentOrderStatus = ActionStatus.Successful;
    state.currentOrder = order;
  },

  getCurrentOrderFailed(state) {
    state.getCurrentOrderStatus = ActionStatus.Failed;
  },

};
